import { useEffect, useState } from 'react'

/** The tablet breakpoint, shared with the stylesheet. */
export const NARROW_BREAKPOINT = 640

/**
 * Whether the viewport is phone-sized.
 *
 * Used to decide layout, not to hide functionality: everything available on a
 * desktop is available onsite, just arranged for one thumb at a time.
 */
export function useIsNarrow(breakpoint = NARROW_BREAKPOINT): boolean {
  const [isNarrow, setIsNarrow] = useState(() =>
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia(`(max-width: ${breakpoint}px)`).matches
      : false,
  )

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return
    }

    // The initial value comes from the useState initializer above; this effect
    // only keeps it in step with later changes. The breakpoint is a constant in
    // practice, so there is nothing to re-read here.
    const query = window.matchMedia(`(max-width: ${breakpoint}px)`)
    const update = (event: MediaQueryListEvent) => setIsNarrow(event.matches)

    query.addEventListener('change', update)

    return () => query.removeEventListener('change', update)
  }, [breakpoint])

  return isNarrow
}
